import { useState, useCallback } from 'react';

export function useMultiSelect() {
    const [selectedIds, setSelectedIds] = useState<number[]>([]);

    const toggleSelect = useCallback((id: number, isCtrlOrCmd: boolean) => {
        if (isCtrlOrCmd) {
            // Ctrl/Cmd + click: toggle pojedynczy element
            setSelectedIds(prev =>
                prev.includes(id)
                    ? prev.filter(i => i !== id)
                    : [...prev, id]
            );
        } else {
            // Zwykły click: zaznacz tylko ten element
            setSelectedIds([id]);
        }
    }, []);

    const selectMultiple = useCallback((ids: number[]) => {
        setSelectedIds(ids);
    }, []);

    const clearSelection = useCallback(() => {
        setSelectedIds([]);
    }, []);

    const isSelected = useCallback((id: number) => {
        return selectedIds.includes(id);
    }, [selectedIds]);

    return {
        selectedIds,
        toggleSelect,
        selectMultiple,
        clearSelection,
        isSelected,
    };
}